import React from 'react'
import classNames from 'classnames'
import TrimbleMap from 'transfix-maps/components/TrimbleMap'
import { IMapPosition, IMapStopProps, WithId } from 'transfix-maps/types'
import { makeStyles } from 'transfix-ui/core'

const useLastPingStyles = makeStyles({
  root: {
    height: 300,

    '& > div': {
      borderRadius: 2,
    },
  },
})

export interface ILastPingMapProps {
  previousRouteCoords: Pick<IMapPosition, 'coords'>[]
  predictedRouteCoords: Pick<IMapPosition, 'coords'>[]
  positions: WithId<Pick<IMapPosition, 'type' | 'coords'>>[]
  pickupsAndDeliveries: WithId<IMapStopProps>[]
}

export const LastPingMap = ({
  previousRouteCoords = [],
  predictedRouteCoords = [],
  positions = [],
  pickupsAndDeliveries = [],
}: ILastPingMapProps) => {
  const classes = useLastPingStyles()
  const className = classNames(classes.root, 'pings-map')
  return (
    <div className={className} data-test='LastPingMap'>
      <TrimbleMap
        dataTest='LastPingMap'
        maxZoom={5}
        fitBoundsOptions={{
          padding: 48,
          animate: false,
        }}
        stops={pickupsAndDeliveries}
        positions={positions}
        lines={[
          {
            id: '1',
            route: previousRouteCoords,
            routeType: 'previous',
            data: {
              id: '1',
            },
          },
          {
            id: '2',
            route: predictedRouteCoords,
            routeType: 'predicted',
            data: {
              id: '2',
            },
          },
        ]}
      />
    </div>
  )
}

export default LastPingMap
